import Header from "./partials/header";
import Scroll from "./assets/scroll";
import Home from "./pages/home";
import Reviews from "./partials/reviews";
import Cases from "./partials/cases";
import Websites from "./pages/website";
import Makelaars from "./pages/makelaars";
import Overons from "./pages/overons";
import Global from "./global";
import Usp from "./partials/usp";
import Recent from "./partials/recent";
import Lazyload from "./lazyload";
import Project from "./pages/project";

//partials
new Header();
new Reviews()
new Cases();
new Usp();
new Recent();

//assets
new Scroll();

//pages
new Home()
new Websites();
new Makelaars();
new Overons();
new Project();


//Global
new Global();
new Lazyload();
